export default {
    SET_GROUPS: (state, groups) => {
        state.groups = groups
    },

    SET_GROUP_STATISTIC: (state, groupStatistic) => {
        state.groupStatistic = groupStatistic
    },

    SET_BUSINESS_GROUP_STATISTIC: (state, groupStatistic) => {
        state.businessGroupStatistic = groupStatistic
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    ADD_CREATED_GROUP: (state, group) => {
        if (state.pagination.limit <= state.groups.length) {
            state.groups.pop()

            state.pagination.length = Math.ceil((state.pagination.total + 1) / state.pagination.limit)
        }

        state.groups.unshift(Object.assign({}, group, {
            existSystem: 0
        }))
    },

    UPDATE_GROUP: (state, group) => {
        const index = state.groups.findIndex(it => it.id == group.id)

        if (index !== -1) {
            Object.assign(state.groups[index], group)
        }
    },

    SET_CLIENTS_COUNT: (state, count) => {
        state.clientsCount = count
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_FILTERS: (state) => {
        state.filters = {
            name: null,
            type: null,
            valuesFrom: null,
            valuesTo: null,
            includeUnallocated: null,
            onlyUnallocated: null,
            accountId: null,
            used: null,
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            isDelivery: null,
            bonusSystem: null
        }
    }
}
